import React from 'react';
import styles from './StatRow.module.css';

const StatRow = ({ label, value }) => (
    <div className={styles.statRow}>
        <span>{label}</span>
        <span className={styles.statValue}>{value}</span>
    </div>
);

export default StatRow;
